import { render, staticRenderFns } from "./CardExpirationReportCompanycards.vue?vue&type=template&id=606c9d41&scoped=true&"
import script from "./CardExpirationReportCompanycards.vue?vue&type=script&lang=ts&"
export * from "./CardExpirationReportCompanycards.vue?vue&type=script&lang=ts&"
import style0 from "./CardExpirationReportCompanycards.vue?vue&type=style&index=0&id=606c9d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c9d41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VLayout,VSpacer,VToolbar,VToolbarTitle})
